import axios from 'axios'

const API_URL = process.env.API_URL

const FETCH_SERVICES = 'FETCH_SERVICES'
const FETCH_SERVICES_RESPONSE = `${FETCH_SERVICES}_RESPONSE`
const RESTART_SERVICE = 'RESTART_SERVICE'
const RESTART_SERVICE_RESPONSE = `${RESTART_SERVICE}_RESPONSE`

const getDefaultState = () => ({
  isFetching: false,
  restarting: null,
  services: []
})

const actions = {
  fetchServices: ({ commit }) => {
    commit(FETCH_SERVICES)
    return axios
      .get(`${API_URL}/services`)
      .then(({ data: { data: services } }) => {
        commit(FETCH_SERVICES_RESPONSE, { services })
      })
  },
  restartService: ({ commit }, service) => {
    commit(RESTART_SERVICE, { service })
    // return new Promise(resolve => setTimeout(resolve, 1000)).then(() => {
    //   commit(RESTART_SERVICE_RESPONSE)
    //   return { service }
    // })
    return axios.post(`${API_URL}/services`, { id: service.id }).then(
      () => {
        commit(RESTART_SERVICE_RESPONSE)
        return { service }
      },
      () => commit(RESTART_SERVICE_RESPONSE, { error: true })
    )
  }
}

const mutations = {
  [FETCH_SERVICES] (state) {
    state.isFetching = true
  },
  [FETCH_SERVICES_RESPONSE] (state, { services }) {
    state.services = services
    state.isFetching = false
  },
  [RESTART_SERVICE] (state, { service }) {
    state.restarting = service
  },
  [RESTART_SERVICE_RESPONSE] (state) {
    state.restarting = null
  }
}

const getters = {
  services: ({ services }) => services,
  isFetching: ({ isFetching }) => isFetching,
  restarting: ({ restarting }) => restarting
}

export default {
  namespaced: true,
  state: getDefaultState(),
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/services.js